import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { BuoyData, BuoyState } from '../types/buoy';
import { BoundingBox } from '../types';
import { NOAABuoyService } from '../services/noaaBuoyService';
import { logger } from '../utils/logger';

const initialState: BuoyState = {
  buoys: [],
  loading: false,
  error: null,
  lastUpdated: null,
};

export const fetchBuoys = createAsyncThunk(
  'buoy/fetchBuoys',
  async (bounds: BoundingBox) => {
    try {
      const buoys = await NOAABuoyService.fetchBuoysInBounds(bounds);
      return {
        buoys,
        timestamp: new Date().toISOString(),
      };
    } catch (error) {
      logger.error('Error fetching buoys', error);
      throw error;
    }
  }
);

const buoySlice = createSlice({
  name: 'buoy',
  initialState,
  reducers: {
    clearBuoys: (state) => {
      state.buoys = [];
      state.error = null;
      state.lastUpdated = null;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBuoys.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBuoys.fulfilled, (state, action) => {
        state.loading = false;
        state.buoys = action.payload.buoys;
        state.lastUpdated = action.payload.timestamp;
        state.error = null;
      })
      .addCase(fetchBuoys.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch buoy data';
      });
  },
});

export const { clearBuoys, setError } = buoySlice.actions;
export default buoySlice.reducer;